import React, { Component } from "react";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";

class AddEditProductBrand extends Component {
  constructor() {
    super();
    this.state = {
      brand: "",
      key: "",
      brandError: "",
      saving: false,
    };
    this.onSaveBrand = this.onSaveBrand.bind(this);
  }

  componentDidMount() {
    let brand = "";
    let key = "";
    if (this.props.productBrand) {
      brand = this.props.productBrand.Brand;
      key = this.props.productBrand.key;
    }
    this.setState({ brand: brand, key: key });
  }

  async onSaveBrand() {
    this.setState({ saving: true });
    let key = this.state.key;
    if (this.state.brand.trim() === "") {
      this.setState({ brandError: "Please provide brand name", saving: false });
      return;
    }
    let isUnique = true;
    console.log(" this.props.config.ProductBrands", this.props.config.ProductBrands);
   
let similarBrands = this.props.config.ProductBrands.filter((e) =>
  e.hasOwnProperty("Brand") &&
  e.Brand &&                          // not null, undefined, or ""
  !e.IsDeleted &&
  e.Brand.trim().toLowerCase() ===
    (this.state.brand || "").trim().toLowerCase()
);
    if (key && key !== "") {
      if (similarBrands.filter((f) => f.key !== key).length > 0) {
        isUnique = false;
      }
    } else if (similarBrands.length > 0) {
      isUnique = false;
    }

    if (!isUnique) {
      this.setState({ brandError: "Brand name already exists", saving: false });
      return;
    } else {
      let omniTag = "";
      let name = this.state.brand;
      omniTag = name
        .replace(/[@!&\/\\#,+()$~%.'"`_:*?<>{}-]/g, "")
        .replace(/ /g, "_");
      let productBrand = {
        Brand: name,
        RegistrationID: this.props.user.user.RegistrationID,
        IsDeleted: false,
        OMNITag: omniTag,
      };
      this.props.saveProductBrand(productBrand, key).then(async (response) => {
        this.setState({ saving: true });
        if (response) {
          if (response.code && response.code === "0") {
            await this.props.getProductBrands();
            this.setState({ saving: false });
              let brandID = key !== "" 
    ? key 
    : (response.brand && response.brand.brandID);
            this.props.onSave(brandID, productBrand.Brand);
          }
          this.props.getToastr(response.message);
        }
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <Window
          header={this.state.key !== "" ? "Edit Brand" : "New Brand"}
          onButtonClick={(action) => {
            if (action.toLowerCase() === "save") {
              this.onSaveBrand();
            } else {
              this.props.onClose();
            }
          }}
          buttons={[
            { Type: "secondary", Text: "Cancel", Align: "left" },
            { Type: "primary", Text: "Save", Align: "right" },
          ]}
          processing={this.state.saving}
          onClose={() => this.props.onClose()}
          slide={true}
        >
          <Input
            type="text"
            label="Brand"
            value={this.state.brand}
            onChange={(value) =>
              this.setState({ brand: value, brandError: "" })
            }
            error={this.state.brandError}
            onEnter={this.onSaveBrand}
          />
        </Window>
      </React.Fragment>
    );
  }
}

export default AddEditProductBrand;
